import React from "react";
import { IoMdArrowRoundBack } from "react-icons/io";
import "./back-header.css";
import { Button } from "@mui/material";

let BackHeader = (props) => {
  return (
    <Button className="back-header-button" onClick={props.backHanler}>
      <IoMdArrowRoundBack size={30} color="#663399" />
    </Button>
  );
};
export default BackHeader;
